import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '../core/route.service';
import { extract } from '../core/i18n.service';
import { EditProcessComponent } from 'app/editProcess/editProcess.component';

const routes: Routes = Route.withShell([
  { path: 'process/editing/:id', component:  EditProcessComponent, data: { titleKey: 'PROCESS.EDIT.PAGE_TITLE' } }
], false);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class EditProcessRoutingModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/editProcess/editProcess-routing.module.ts